// extracted by mini-css-extract-plugin
export default {"colors":"'assets/css/colors.module.css'","textColor":"#182C3D","enroll-button":"buttons_enroll-button__K17L0","enroll":"buttons_enroll__+Nlco"};